import { gql } from '@biletiniz/apollo';

export const RESET_PASSWORD = gql`
  mutation resetPassword(
    $username: String!
    $code: String!
    $password: String!
  ) {
    resetPassword(username: $username, code: $code, password: $password) {
      message
      status
      token {
        accessToken
        accessTokenExpiresAt
        refreshToken
        refreshTokenExpiresAt
        user {
          name
          surname
          email
          phoneNumber
          balance {
            amount
            currency
          }
        }
      }
    }
  }
`;
